module.exports = __webpack_public_path__ + "img/ecommerce.category.content_image_13.a99061e8.webp";